import React from 'react';
import { LazySection } from './LazySection';
export function Dolores() {
  return <LazySection className="bg-cream" data-id="element-115">
      <div className="container-custom" data-id="element-116">
        <div className="text-center" data-id="element-117">
          <span className="eyebrow" data-id="element-118">Si te pasa esto, seguí leyendo</span>
        </div>
        <h2 className="text-[clamp(32px,4.8vw,50px)] text-center mb-4" data-id="element-119">
          Si ya lo intentaste <em data-id="element-120">todo</em> y el{' '}
          <span className="highlight-keyword" data-id="element-121">patrón</span> <em data-id="element-122">sigue ahí</em>…
        </h2>
        <p className="text-center text-ink-soft text-[17px] max-w-[640px] mx-auto mb-[50px]" data-id="element-123">
          Fijate si alguna de estas situaciones te resulta familiar:
        </p>

        <div className="flex flex-col gap-3 max-w-[760px] mx-auto mt-6 mb-[50px]" data-id="element-124">
          {[<>
              <strong data-id="element-125">Elegís al mismo tipo de persona</strong> — aunque jures
              que esta vez será distinto.
            </>, <>
              A punto de ser feliz, <strong data-id="element-126">algo dentro tuyo lo arruina</strong>{' '}
              sin saber por qué.
            </>, <>
              Cargás una <strong data-id="element-127">tristeza inexplicable</strong> que no coincide
              con tu historia.
            </>, <>
              Llevás años en terapia. Lo entendés, pero el{' '}
              <span className="highlight-keyword" data-id="element-128">patrón</span> sigue ahí.
            </>, <>
              <strong data-id="element-129">Te cuesta recibir</strong> — amor, dinero o reconocimiento
              te incomodan.
            </>, <>
              Sabés qué hacer, pero <strong data-id="element-130">algo más fuerte te frena</strong> y
              te desespera.
            </>].map((content, i) => <div key={i} className="bg-white border border-border border-l-[3px] border-l-red-x rounded-xl p-5 md:px-[26px] flex items-start gap-4 transition-all duration-200 hover:translate-x-1 hover:shadow-soft opacity-100" data-id="element-131">
              <span className="text-red-x text-[20px] font-semibold shrink-0 leading-[1.2]" data-id="element-132">
                ✕
              </span>
              <p className="font-serif italic text-[17px] text-ink leading-[1.45]" data-id="element-133">
                {content}
              </p>
            </div>)}
        </div>

        <p className="text-center font-serif italic text-[clamp(22px,3.2vw,32px)] text-gold-dark max-w-[720px] mx-auto leading-[1.3]" data-id="element-134">
          No es falta de voluntad.{' '}
          <strong className="not-italic text-ink font-medium bg-gradient-to-b from-transparent from-60% to-gold/30 to-60% px-1" data-id="element-135">
            Es el mapa <span className="highlight-keyword" data-id="element-136">generacional</span>{' '}
            que tu terapia no te dio.
          </strong>
        </p>
      </div>
    </LazySection>;
}